module.exports = __webpack_public_path__ + "img/zxyw_icon_web.27f290dc.png";